import React from "react";
import Styles from "./index.module.scss";
import { Button } from "antd";
import classNames from "classnames";
import { useHistory } from "react-router-dom";
import { NoWeekTimeCourse } from "API";
import { isTrue } from "../../../../../Utils/filter";
import { evaluationStatus } from "../../../../../API/evaluate";

interface Props {
    item: NoWeekTimeCourse;
}
const Index = ({ item }: Props) => {
    const history = useHistory();
    function navTo() {
        history.push(
            `/evaluate/${item.evaluationId}/${item.multiEvaluationFlag}`
        );
    }

    return (
        <div className={Styles.root}>
            <div className={Styles.content}>
                <div className={Styles.title}>{item.courseName}</div>
                <p className={Styles.info}>
                    课程编号：{item.courseNo} - 课序号：{item.courseSeq}
                </p>
                <p className={Styles.info}>授课教师：{item.teacherName}</p>
                <span
                    className={classNames(Styles.status, {
                        [Styles.statusNone]: isTrue(
                            item.evaluationStatus === evaluationStatus.Evaluated
                        )
                    })}>
                    {isTrue(
                        item.evaluationStatus === evaluationStatus.Evaluated
                    )
                        ? "已评价"
                        : "待评价"}
                </span>
            </div>
            <div className={Styles.footer}>
                <Button
                    size="small"
                    icon="star"
                    ghost
                    type="primary"
                    onClick={navTo}>
                    评价
                </Button>
            </div>
        </div>
    );
};

export default Index;
